import React, { useState } from "react";
import propTypes from "prop-types";

export interface IEditableContainerContext {
    group: string | null;
    setGroup: (group: string | null) => void;
}
export const EditableContainerContext = React.createContext<Partial<IEditableContainerContext>>({});


const EditableContainer: React.FunctionComponent<{
    children: React.ReactNode
}> = (props) => {
    const [group, setGroup] = useState<string | null>(null);
    return <EditableContainerContext.Provider value={{
        setGroup: (g) => {
            setGroup(g);
        },
        group: group
    }}>
        {props.children}
    </EditableContainerContext.Provider>
}

EditableContainer.propTypes = {
    children: propTypes.any.isRequired
}

export default EditableContainer;